import React, { useContext, useEffect } from "react";
import Footer from "../components/footer";
import bg from "../assets/images/bg frown.webp";
import hi from "../assets/images/hi.webp";
import work from "../assets/images/work.webp";
import idea from "../assets/images/idea.webp";
import watch from "../assets/images/watch.gif";
import phone from "../assets/images/road map.gif";
import tab from "../assets/images/tab open.gif";
import tesla from "../assets/images/tesla.webp";
import bgSmile from "../assets/images/bg smile.webp";
import stars from "../assets/images/stars.webp";
import "../styles/about.scss";
import AppContext from "../context/context";

function About() {
  const { navDark, setTopOn } = useContext(AppContext);
  useEffect(() => {
    setTopOn(false);
  }, [setTopOn]);
  return (
    <>
      <section id="first">
        <img src={bg} alt="bg" className={`${navDark ? "active" : ""}`} />
        <h1>Yep,</h1>
        <h1>that's me!</h1>
      </section>
      <section id="intro">
        <div className="hero-con">
          <div className="text-con">
            <h1>Who am I?</h1>
            <p>
              My name is <span> Kolade</span> and I’m a{" "}
              <span> Product Designer based in Lagos</span>, NG. I have a
              Masters in Architecture, and a background in Graphics design.
            </p>
          </div>
          <img src={hi} alt="hi" />
        </div>
        <div className="hero-con rev">
          <div className="text-con ">
            <h1>What do I do?</h1>
            <p>
              <span>
                {" "}
                As a technology geek and a person who loves to attend UX
                conferences. I also bring with me a diverse culture that
                influences my design
              </span>
              . My background in Architecture also helps me look at design from
              an ergonomics point of view in addition to advocating for user’s
              needs and desires.
            </p>
            <p className="pe">
              Currently, I'm designing experiences for Access Bank.
            </p>
          </div>
          <img src={work} alt="" />
        </div>
        <div className="hero-con">
          <div className="text-con">
            <h1>What am I passionate about?</h1>
            <p>
              <span>
                {" "}
                I have a healthy obsession with how people interact with
                technology and connect people to ideas in a way that generates
                excitement
              </span>
              . I am curious and I like diving deep into emerging tech and
              latest trends to know more new spaces.
            </p>
          </div>
          <img src={idea} alt="" />
        </div>
        <div className="gif-box">
          <img src={watch} alt="watch" className="watch" />
          <img src={phone} alt="tesla" className="phone" />
          <img src={tab} alt="tesla" className="tab" />
          <img src={tesla} alt="tesla" className="tesla" />
        </div>
        <p className="peter">
          Couple of trends I study and follow in my free time over Twitter and
          Verge
        </p>
      </section>
      <section id="review">
        <img src={bgSmile} alt="" className="smile" />
        <div className="review-con">
          <div className="review-text">
            <div className="header">
              <h1>Reviews</h1>
              <p>What people say about Kola.</p>
            </div>
            <div className="para-box">
              <p>
                "I highly recommend Kolade as a multidisciplinary designer. His
                ability to seamlessly integrate multiple design disciplines and
                deliver exceptional results is truly impressive. He is a true
                master of his craft and a pleasure to work with. I have no doubt
                that he will continue to excel in his career."
              </p>
              <div className="p-box">
                <p>
                  Nathaniel Ike, <span> Forbes Africa 30 U’ 30</span>
                </p>
                <img src={stars} alt="stars" />
              </div>
            </div>
            <div className="para-box">
              <p>
                "When it comes to creating great designs, I have known Kolade
                Abraham for some years now as a competent designer with the
                ability to create great designs seamlessly. When It comes to
                delivering exceptional creative results, I highly recommend him
                and I have no doubt he will deliver.."
              </p>
              <div className="p-box">
                <p>
                  ‘dimeji Oyeniran, <span> Brand Consultant</span>
                </p>
                <img src={stars} alt="stars" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default About;
